import { render } from "./05_Services.vue?vue&type=template&id=f5ad2fb2&scoped=true"
import script from "./05_Services.vue?vue&type=script&lang=js"
export * from "./05_Services.vue?vue&type=script&lang=js"

import "./05_Services.vue?vue&type=style&index=0&id=f5ad2fb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5ad2fb2"]])

export default __exports__